import React, { useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner'; // ✅ Import loader
import BASE_URL from '../config';

const MySwal = withReactContent(Swal);

const showToast = (icon, title, text) => {
  MySwal.fire({
    toast: true,
    position: 'top',
    icon: icon,
    title: title,
    text: text,
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
  });
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // ✅ Loader state

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError('Email is required');
      return;
    }

    setLoading(true); // ✅ Show loader

    try {
      const response = await axios.post(
        `${BASE_URL}/api/forgot-password`,
        { email },
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );
      showToast('success', 'Success', response.data.message || 'Reset link sent to your email');
      setEmail('');
      navigate('/login');
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to send reset link.';
      showToast('error', 'Error', message);
    } finally {
      setLoading(false); // ✅ Hide loader
    }
  };

  return (
    <div className="loginscreen d-flex align-items-center justify-content-center">
      <div className="login-box p-4 shadow text-center" style={{ minWidth: '320px' }}>
        <h4 style={{ color: '#fff' }}>
          BI <span style={{ color: '#FF650F' }}>Manager</span>
        </h4>

        {loading ? (
          <div className="d-flex justify-content-center my-4">
            <Circles height="50" width="50" color="#FF650F" />
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <input
                type="email"
                name="email"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                placeholder="Enter your email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError('');
                }}
              />
              {error && <div className="invalid-feedback">{error}</div>}
            </div>
            <button type="submit" className="btn btn-primary btn-block w-100">
              Send Reset Link
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
